import { extractError } from "api/ErrorUtil";
import { PAYMENTINTENT_CARD_TOKEN_URL } from "config/config";
import { API } from "api/API";

export const openLightbox = async (payer, handleResult) => {
    let txTokenResp = null;
    try {
        //here formdata payer info is all that i needed
        txTokenResp = await API.post(PAYMENTINTENT_CARD_TOKEN_URL, payer);
    } catch (error) {
        let errors = extractError(error);
        handleResult({result: "ERROR",errors})
    }

    let paymentFields = {
        ssl_txn_auth_token: txTokenResp.data.id,
    };

    let callback = {
        onError: function (error) {
            handleResult({paymentStatus: "ERROR",errors: { message: error } });
        },
        onCancelled: function () {
            handleResult({paymentStatus: "CANCELLED", errors: { message: 'Adding card was cancelled' } });
        },
        onDeclined: function (response) {
            handleResult({paymentStatus: "DECLINED", errors: { message: 'Card was declined. Please try again' }, response });
        },
        onApproval: function (response) {
            handleResult({paymentStatus:'SUCCEEDED', errors: {}, response: response, tokenId: txTokenResp.data.id});
        }
    };
    window['PayWithConverge'].open(paymentFields, callback);
    return false;
} 